import { Tabs, Tab } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import { GoBackButton } from "../../../../components/GoBackButton";
import { LoadingBackDrop } from "../../../../components/loader";
import { theme } from "../../../../helpers/theme";
import { getOperatorClientsById } from "../../../../services/clients/getById";
import { getAllSubcontractor } from "../../../../services/subcontractor/get-all";
import { Contractor, getAllSubcontractorPayload } from "../../../../services/subcontractor/get-all/types";
import AddressSubcontractorEditForm from "./AddressSubcontractorEditForm";
import BasicSubcontractorEditForm from "./BasicSubcontractorEditForm";




interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      className="tabPanel"
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}


export const EditUserSubcontractorData = () => {
  const { id } = useParams();

  const [userSubcontractor, setUserSubcontractor] = useState<Contractor[]>([]);

  const body = {
    paginacja: null,
    filtry: {
      id_wykonawcy: id,
    },
  };

  const GetOperatorSubcontractorsById = useQuery(
    ["AllOperatorSubcontractors"],
    () => getAllSubcontractor(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setUserSubcontractor(data.data.payload.wykonawcy);
      },
    }
  );

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (GetOperatorSubcontractorsById.isLoading || GetOperatorSubcontractorsById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <FormWrapper>
        {/* <ButtonWrapper> */}
        <Tabs
          sx={{
            width: "70%",
          }}
          centered
          value={value} onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Dane Podstawowe" />
          <Tab label="Adres" />
        </Tabs>
        {/* </ButtonWrapper> */}

        <TabPanel value={value} index={0}>
          <BasicSubcontractorEditForm {...userSubcontractor} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddressSubcontractorEditForm {...userSubcontractor} />
        </TabPanel>
      </FormWrapper>
    </>
  );
};

export default EditUserSubcontractorData;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  // padding: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }

  .tabPanel {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;


  @media (${theme.device.laptop}) {
    margin-left: 320px
  }
`;